module.exports = __webpack_public_path__ + "static/media/calendar-blk.7a5dd9c2.svg";